<template lang="pug">
	.atendimentos-dia-container
		.conteudo-atendimentos
			.unidade
				img(src="../../assets/unidades.svg")
				.endereco
					.consultorio Consultório CG
					.logradouro Av. Afonso Pena 2045, Centro - Campo Grande / MS
				.btn
					i(class="el-icon-arrow-down")
			.calendario
				.slide-data
					a.left(@click.prevent="getPrevDate")
						i(class="fa fa-angle-left", aria-hidden="true")
					.conteudo-data
						.dia-semana {{ date | weekDate }}
						.dia-mes {{ date | formatDate }}
					a.right(@click.prevent="getNextDate")
						i(class="fa fa-angle-right", aria-hidden="true")
			ul.corpo-lista
				li.lista
					.horario
						img(src="../../assets/paciente.svg")
						span 08:00
					.info
						.procedimento Eletroneuromiografia Membros Superiores
						.nome-paciente Ana Kelly Aquino Moreira
						.dados-paciente 654.951.964-00 - 08/03/1959 - 61 anos
					.cx-botao
						.botao
							el-button(type="primary", plain) Anotações
								i(class="fa fa-pencil", aria-hidden="true")
						.botao
							el-button(type="primary", plain) Laudo
								i(class="fa fa-pencil", aria-hidden="true")
						.botao
							el-button(type="primary", style="background:#0180FF;") Resultados
								i(class="fa fa-cloud-upload", aria-hidden="true", style="color:#fff;transform: rotate(0);")
				li.lista
					.horario
						img(src="../../assets/paciente.svg")
						span 08:00
					.info
						.procedimento Eletroneuromiografia Membros Superiores
						.nome-paciente Ana Kelly Aquino Moreira
						.dados-paciente 654.951.964-00 - 08/03/1959 - 61 anos
					.cx-botao
						.botao
							el-button(type="primary", plain) Anotações
								i(class="fa fa-pencil", aria-hidden="true")
						.botao
							el-button(type="primary", plain) Laudo
								i(class="fa fa-pencil", aria-hidden="true")
						.botao
							el-button(type="primary", style="background:#0180FF;") Resultados
								i(class="fa fa-cloud-upload", aria-hidden="true", style="color:#fff;transform: rotate(0);")
				li.lista
					.horario
						img(src="../../assets/paciente.svg")
						span 08:00
					.info
						.procedimento Eletroneuromiografia Membros Superiores
						.nome-paciente Ana Kelly Aquino Moreira
						.dados-paciente 654.951.964-00 - 08/03/1959 - 61 anos
					.cx-botao
						.botao
							el-button(type="primary", plain) Anotações
								i(class="fa fa-pencil", aria-hidden="true")
						.botao
							el-button(type="primary", plain) Laudo
								i(class="fa fa-pencil", aria-hidden="true")
						.botao
							el-button(type="primary", style="background:#0180FF;") Resultados
								i(class="fa fa-cloud-upload", aria-hidden="true", style="color:#fff;transform: rotate(0);")
				li.lista
					.horario
						img(src="../../assets/paciente.svg")
						span 08:00
					.info
						.procedimento Eletroneuromiografia Membros Superiores
						.nome-paciente Ana Kelly Aquino Moreira
						.dados-paciente 654.951.964-00 - 08/03/1959 - 61 anos
					.cx-botao
						.botao
							el-button(type="primary", plain) Anotações
								i(class="fa fa-pencil", aria-hidden="true")
						.botao
							el-button(type="primary", plain) Laudo
								i(class="fa fa-pencil", aria-hidden="true")
						.botao
							el-button(type="primary", style="background:#0180FF;") Resultados
								i(class="fa fa-cloud-upload", aria-hidden="true", style="color:#fff;transform: rotate(0);")
</template>

<script>
import moment from 'moment'
moment.locale('pt-BR')

export default {
	data: () => ({
		date: new Date()
	}),

	filters: {
    formatDate(x) {
      return moment(x).format('LL')
    },
    weekDate(x) {
      return moment(x).format('dddd')
    }
  },

	methods: {
		getPrevDate() {
      let date = moment(new Date(this.date)).add(-1, 'days')
      this.date = date
    },
    getNextDate() {
      let date = moment(new Date(this.date)).add(1, 'days')
      this.date = date
    }
	}
}
</script>

<style lang="scss">
.atendimentos-dia-container{
	width: 1100px;
  height: calc(100% - 120px);
  margin: 0 auto;
  overflow: auto;
  
  &::-webkit-scrollbar {
    display: none;
  }

	.conteudo-atendimentos{
		margin-top: 25px;

		.unidade{
			width: 100%;
			height: 85px;
			border: 1px solid #cbcbcb;
      border-radius: 10px;
      padding: 13px 29px;
      box-sizing: border-box;
      margin-top: 20px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			cursor: pointer;

			.endereco{
				text-align: center;

				.consultorio{
					font-size: 23px;
    			font-weight: 500;
				}
				.logradouro{
					font-size: 16px;
					font-weight: 100;
				}
			}
			.btn {
				width: 52px;
				height: 52px;
				background: #F1F8FF;
				border-radius: 100px;
				display: flex;
				align-items: center;
				justify-content: center;

				i{
					color: #0180FF;
					font-size: 26px;
					font-weight: bold;
				}
			}
		}
		.calendario {
      position: relative;
      width: 100%;
      height: 85px;
      border: 1px solid #cbcbcb;
      border-radius: 10px;
      padding: 13px 29px;
      box-sizing: border-box;
      margin-top: 20px;
      display: flex;
      align-items: center;
      
			.slide-data {
        position: absolute;
        width: 405px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        left: 50%;
        transform: translateX(-50%);

        .conteudo-data {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          .dia-semana {
            color: #0180ff;
            font-size: 22px;
            font-weight: 600;
            margin-bottom: 5px;
						text-transform: capitalize;
          }
          .dia-mes {
            color: #000;
            font-size: 17px;
          }
        }

        .left,
        .right {
          width: 52px;
          height: 52px;
          background: #f1f8ff;
          border-radius: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          i {
            color: #0180ff;
            font-size: 33px;
            line-height: 0;
          }
        }
      }
    }

		ul.corpo-lista{
			margin: 20px 0;
			padding: 0;
			width: 100%;

			li.lista{
				list-style: none;
				width: 100%;
				height: 115px;
				border: 1px solid #CBCBCB;
				border-radius: 8px;
				margin-bottom: 20px;
				box-sizing: border-box;
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 0 25px;

				&:last-child{
					margin-bottom: 0;
				}

				.horario {
					height: 100%;
					display: flex;
					flex-direction: column;
					justify-content: center;

					img{
						margin-bottom: 10px;
					}
					span{
						font-size: 20px;
					}
				}
				.info {
					flex: 1;
					margin-left: 25px;
					height: 100%;
					display: flex;
					flex-direction: column;
					justify-content: center;

					.procedimento{
						font-size: 20px;
						color: #0180FF;
						font-weight: 500;
						margin-bottom: 5px;
					}
					.nome-paciente{
						font-size: 20px;
						color: #000;
					}
					.dados-paciente{
						font-size: 18px;
						color: #000;
						font-weight: 100;
					}
				}
				.cx-botao{
					display: flex;

					.botao{
						width: 160px;
						height: 50px;

						&:nth-child(2){
							margin: 0 15px;
						}

						.el-button{
							width: 100%;
							height: 100%;
							border-radius: 8px;
							font-size: 17px;
							border-color: #0180FF;

							span{
								height: 100%;
								display: flex;
								align-items: center;
								justify-content: space-between;

								i{
									transform: rotate(-10deg);
									margin-left: 15px;
									font-size: 25px;
								}
							}


							&.el-button--primary.is-plain:focus,
							&.el-button--primary.is-plain:hover{
								color: #409EFF;
								background: #ecf5ff;
								border-color: #0180FF;
							}
						}
					}
				}
			}
		}
	}
}
</style>